import React from 'react';
import ReactDOM from 'react-dom/client';
import AvailabilityBar from './AvailabilityBar';
import { AuthenticationProvider } from '../../../my-dashboard/context/AuthenticationContext';
const $availabilityBars: NodeListOf<HTMLElement> | null = document.querySelectorAll('.timken-availability-bar');
if ($availabilityBars) {
	$availabilityBars.forEach(($bar) => {
		const availability = parseInt($bar.dataset.availability || '0', 10);

		const $root = ReactDOM.createRoot($bar as HTMLElement);
		$root.render(
			<React.StrictMode>
                <AuthenticationProvider>
				    <AvailabilityBar availability={availability} />
                </AuthenticationProvider>
			</React.StrictMode>
		);
	});
}
